import { render, staticRenderFns } from "./fazhi.vue?vue&type=template&id=6358916c&scoped=true&"
import script from "./fazhi.vue?vue&type=script&lang=js&"
export * from "./fazhi.vue?vue&type=script&lang=js&"
import style0 from "./fazhi.vue?vue&type=style&index=0&id=6358916c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358916c",
  null
  
)

export default component.exports